import { Column, FMColumn } from '../model';

import { SizeCell } from '../components/cells/SizeCell';

import { FVCBytes } from '../components/plugins/filters/FilterValueContainer';
import { Type } from '../../../../general/modules/filter/dataModel';
import fileSize from 'filesize';

export const sizeCol: FMColumn<Type.BYTES> = {
  key: Column.size,
  dataKey: Column.size,
  title: 'Size',
  width: 110,
  sortable: true,
  cellRenderer: SizeCell,
  className: 'ch-file-manager__cell_size',
  filter: Type.BYTES,
  plugins: [FVCBytes],
  getter: (row) => row.size,
  toDisplayString: (row) => (row.size === null ? '<no size>' : fileSize(row.size)),
};
